import ServiceWrapper from "./ServiceWrapper";

export default class Service {
	protected wrapper: ServiceWrapper;
	constructor() {
		this.wrapper = new ServiceWrapper();
	}
}
